module.exports = __webpack_public_path__ + "static/img/1_03.2a1e32c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/images/1/1_03.png
// module id = IZi0
// module chunks = 3